import goals from "../utils/goals";
import { UploadCheckout } from "./UploadCheckout";
import FilesApi from "../api/files";

export class UploadCheckoutPromo extends UploadCheckout {

    init() {
        super.init();
        this.transcribeBtn.on('click', this.onTranscodeBtnClick.bind(this));

    }

    update(files) {
    }

    onTranscodeBtnClick(e) {
        e.preventDefault();

        // if (!this.acceptTerms.isChecked()) {
        //     this.acceptTerms.shake(30, 5, 5);
        //     return;
        // }

        goals.reach("transcodePromo");
        this.transcribeBtn.disable();

        FilesApi.transcribe(this.parent.getFiles())
            .then((response) => {

                this.transcribeBtn.enable();
                if (response.offers && Object.keys(response.offers).length > 0) {
                    this.handleOfferResponse(response);

                }
            })
            .catch((errors) => {
                this.transcribeBtn.enable();
                this.errorBag.show(errors);
            });
    }
}
